module.exports = __webpack_public_path__ + "static/media/heart-filled-icon.985d21e1.svg";